<div class="grid">
  <div class="col-12 md:ml-5 py-4">
    <app-dynamic-form [readonly]="readonly"
      [leftLabels]="leftLabels"
      [formTemplateJson]="formTemplateJson"
      [formValuesJson]="formValuesJson"
      (formStatusEvent)="dynamicFormStatus($event)"
      (formValuesEvent)="dynamicFormChange($event)" />
  </div>
</div>
